import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../nav/AppDimensions.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance } from '../../../../screens/common/ProjectView.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77 } from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { keyString2ezqnhf3jck9c as keyString } from '../../../keyValue.mjs';
import {
  divkhq3vjih9fcw as div,
  Dimensions32ju1l7z4mh as Dimension,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
  get_dialogStackleaqvayyucjw as get_dialogStack,
} from '../../../nav/crowpay.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  body3i5t0n7zprpqb as body,
} from '../../../../theming/Titles.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { ListSemantic_getInstance1hx6c2zatma42 as ListSemantic_getInstance } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { get_lightSection4cpu8okr0w14 as get_lightSection } from '../../../../theming/sections.mjs';
import { lineItemCard17zaiwgczjtrr as lineItemCard } from './cards.mjs';
import {
  forEachMaybeReorderable1aeoqjpfy2fje as forEachMaybeReorderable,
  reorderts8zja415q79 as reorder,
} from '../../../reordering.mjs';
import {
  Indent_HalfSection_getInstance3e9u4kbpkw4rx as Indent_HalfSection_getInstance,
  indented3383b46h9g40w as indented,
} from '../../../space.mjs';
import {
  get_unpadded3gipn3ftxgnwh as get_unpadded,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { get_px8ok5q0jdway2 as get_px } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  workItemTableHeader1i5k4rlwsgce6 as workItemTableHeader,
  workItemTableRow1fg7z95rbicqi as workItemTableRow,
} from './tables.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../../../theming/separators.mjs';
import {
  get_rawSession1kjo1nj4tz6n0 as get_rawSession,
  lensUnread1tcpdysie4g78 as lensUnread,
  get_session9cytjmfbg8nd as get_session,
} from '../../../../../sdk/UserSession.mjs';
import { handleOne3ny7r4k654tcd as handleOne } from '../../../../../extensions/HasReadBy.ext.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  setOf1u3mizs95ngxo as setOf,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  filter31kgiqs90is7g as filter,
  lensFilter5xvs6ea8thrl as lensFilter,
} from '../../../../../utils/utils.mjs';
import { renderLineItemDetails23mbed1k3mdfc as renderLineItemDetails } from './lineItemDetails.mjs';
import { renderScopeView29s6jurmhfcza as renderScopeView } from './renderScopeView.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atTopStart2sqdmdfleu6ji as get_atTopStart,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  specCenteredText1zemopd0g3rsf as specCenteredText,
  specCenteredContent3evlhhbrk2e00 as specCenteredContent,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
} from '../../../../theming/buttons.mjs';
import { get_compact3lsezez8nz8b6 as get_compact } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  ProjectState_PendingStart_getInstance2dqkzmcm0blyg as ProjectState_PendingStart_getInstance,
  ProjectState_InProgress_getInstance2qplvnabv8loq as ProjectState_InProgress_getInstance,
  LineItemState_NotStarted_getInstance3brd4lyoananz as LineItemState_NotStarted_getInstance,
  LineItemState_Complete_getInstancefayisedsonfg as LineItemState_Complete_getInstance,
} from '../../../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { setOf45ia9pnfhe90 as setOf_0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  newNotesAllowed1s45uieazjo3d as newNotesAllowed,
  newNotesAllowedq5ynuueymgu2 as newNotesAllowed_0,
  newTasksAllowed26ihc5f4iqgon as newTasksAllowed,
  newTasksAllowed2g7c6d9oaegnt as newTasksAllowed_0,
} from '../../../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Movepj4bxmsunu5w as Move } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/forEachReorderable.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { JumpTo_getInstance3ru9x2o8nieur as JumpTo_getInstance } from '../../../../../utils/JumpTo.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { StartWorkItemsDialogs82uh5psoxv6 as StartWorkItemsDialog } from '../../../../dialogs/StartWorkItemsDialog.mjs';
import { infoBubblebw7xb14ivkdr as infoBubble } from '../../../iconShortcuts.mjs';
import { NewScopeViewDialog2llneu31ficjx as NewScopeViewDialog } from '../../../../dialogs/NewScopeViewDialog.mjs';
import {
  RootCreateItemNote3hjykvgwuyehp as RootCreateItemNote,
  RootCreateItemTask3hcc6ixs4t028 as RootCreateItemTask,
} from '../../../../dialogs/LineItemDialogs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function scopeV3(_this__u8e3s4, writer) {
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.cbb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.ebb(p, view);
  view.xbm(true);
  view.zb8(get_AppDimensions().zg1_1);
  if (_this__u8e3s4.rgj().equals(ProjectLens_Contractor_getInstance())) {
    actions(_this__u8e3s4, view);
  }
  var tmp = shownWhen(view, true, ($this$shownWhen) => $this$shownWhen.baj(_this__u8e3s4.lgj_1));
  view.jbb(tmp, keyString(view, 'Total Value', ($this$keyString) => MonetaryValue__toString_impl_xslc77($this$keyString.baj(_this__u8e3s4.jfy()).y7b_1)));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  if (get_viewIsWide(view_0)) {
    view_0.zb8(div(view_0.kba().hb0_1, 2));
  }
  var individualItems = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.baj(_this__u8e3s4.tgm());
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (!element.y91()) {
        destination.v(element);
      }
    }
    return destination;
  });
  var tmp_0 = KMutableProperty0();
  var tmp_1 = RowOrCol$_get_shown_$ref_m8lfse(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('shown', 0, tmp_0, tmp_1, RowOrCol$_set_shown_$ref_7290m6(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    var tmp$ret$4 = !$this$reactiveScope.baj(individualItems).i1();
    this_0.set(tmp$ret$4);
    return Unit_instance;
  });
  // Inline function 'com.crowpay.views.theming.subTitle' call
  var content = 'Work Items';
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.jba(view_1.ob6_1.ybe(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_2 = view_1.tb5_1;
  var tmp_3;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content) === 0) {
    tmp_3 = '\xA0';
  } else {
    tmp_3 = content;
  }
  tmp_2.fbu(tmp_3);
  view_0.fbb(p_1, view_1);
  if (get_viewIsWide(view_0)) {
    // Inline function 'com.crowpay.views.components.indentedCol' call
    var indent = Indent_HalfSection_getInstance();
    var tmp2 = indent.ygq_1;
    // Inline function 'com.crowpay.views.components.indentedCol' call
    var afterSpace = indent.zgq_1;
    var tmp_4 = get_unpadded(view_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (Frame())(view_0.pc());
    var tmp0_elvis_lhs_2 = view_0.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
    view_0.ebb(p_2, view_2);
    var tmp_5;
    var tmp_6 = null;
    if (!((tmp_6 == null ? null : new (Dimension())(tmp_6)) == null)) {
      tmp_5 = sizeConstraints(view_2, VOID, VOID, VOID, VOID, VOID, null);
    } else {
      tmp_5 = Companion_getInstance();
    }
    var tmp_7 = view_2.ibb(tmp_5, indented(view_2, tmp2, afterSpace));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (RowOrCol())(view_2.pc());
    var tmp0_elvis_lhs_3 = view_2.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
    view_2.ebb(p_3, view_3);
    view_3.xbm(true);
    view_3.zb8(get_px(0));
    workItemTableHeader(view_3, true, _this__u8e3s4.rgj().equals(ProjectLens_Contractor_getInstance()));
    greySeparator(view_3);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (RowOrCol())(view_3.pc());
    var tmp0_elvis_lhs_4 = view_3.cbb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
    view_3.ebb(p_4, view_4);
    view_4.xbm(true);
    view_4.zb8(get_px(0));
    var tmp_8 = scopeV3$slambda_0(individualItems);
    var tmp_9 = _this__u8e3s4.rgj().equals(ProjectLens_Contractor_getInstance());
    forEachMaybeReorderable(view_4, individualItems, 'individual', tmp_8, tmp_9, VOID, ($this$forEachMaybeReorderable, item, dragData) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())($this$forEachMaybeReorderable.pc());
      var tmp0_elvis_lhs = $this$forEachMaybeReorderable.cbb_1;
      var p = tmp0_elvis_lhs == null ? $this$forEachMaybeReorderable : tmp0_elvis_lhs;
      $this$forEachMaybeReorderable.ebb(p, view);
      view.xbm(true);
      view.zb8(get_px(0));
      var expand = Signal().fak(false);
      var tmp = get_rawSession();
      var unread = lensUnread(tmp, (session) => {
        var tmp = handleOne(session.mfv_1, ($this$handleOne, it) => $this$handleOne.baj(item).hf9_1);
        var tmp_0 = tmp.sfw(session.zfv_1.eft(VOID, ($this$isUnread, it) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$isUnread.baj(_this__u8e3s4.xgz());
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (equals(element.f5p_1, $this$isUnread.baj(item).kf9_1)) {
              destination.v(element);
            }
          }
          return destination;
        }));
        var tmp_1 = tmp_0.sfw(session.rfv_1.eft(VOID, ($this$isUnread, it) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$isUnread.baj(_this__u8e3s4.ugm());
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (equals(element.n7w_1, $this$isUnread.baj(item).kf9_1)) {
              destination.v(element);
            }
          }
          return destination;
        }));
        var tmp_2 = tmp_1.sfw(session.nfv_1.eft(VOID, ($this$isUnread, it) => $this$isUnread.baj(item).jf9_1));
        return tmp_2.sfw(session.mfv_1.ofu(VOID, VOID, ($this$creditsIsUnread) => setOf($this$creditsIsUnread.baj(item).hf9_1)));
      });
      var row = workItemTableRow(_this__u8e3s4, expand, item, view, unread, VOID, dragData);
      launch(view, VOID, VOID, scopeV3$lambda$slambda_0(item, row, expand));
      var tmp_0 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(expand));
      var tmp_1 = _this__u8e3s4.xgz();
      var tmp_2 = filter(tmp_1, ($this$filter, it) => equals(it.f5p_1, $this$filter.baj(item).kf9_1));
      var tmp_3 = _this__u8e3s4.ugm();
      var tmp_4 = filter(tmp_3, ($this$filter, it) => equals(it.n7w_1, $this$filter.baj(item).kf9_1));
      var tmp_5 = _this__u8e3s4.bgt();
      view.jbb(tmp_0, renderLineItemDetails(_this__u8e3s4, item, tmp_2, tmp_4, filter(tmp_5, ($this$filter, it) => it.a6h_1.equals($this$filter.baj(item).kf9_1)), expand, view));
      greySeparator(view);
      $this$forEachMaybeReorderable.fbb(p, view);
      return view;
    });
    view_3.fbb(p_4, view_4);
    view_2.fbb(p_3, view_3);
    view_2.jbb(tmp_7, view_3);
    view_0.fbb(p_2, view_2);
    view_0.jbb(tmp_4, view_2);
  } else {
    var tmp_10 = view_0.hbb(ListSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (RowOrCol())(view_0.pc());
    var tmp0_elvis_lhs_5 = view_0.cbb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_0 : tmp0_elvis_lhs_5;
    view_0.ebb(p_5, view_5);
    view_5.xbm(true);
    var tmp_11 = scopeV3$slambda_2(individualItems);
    var tmp_12 = _this__u8e3s4.rgj().equals(ProjectLens_Contractor_getInstance());
    forEachMaybeReorderable(view_5, individualItems, 'individual', tmp_11, tmp_12, VOID, ($this$forEachMaybeReorderable, item, dragData) => {
      var card = Signal().fak(null);
      get_lightSection($this$forEachMaybeReorderable);
      var c = lineItemCard(_this__u8e3s4, item, _this__u8e3s4.rgj(), dragData, $this$forEachMaybeReorderable);
      card.mam(c);
      return c;
    });
    view_0.fbb(p_5, view_5);
    view_0.jbb(tmp_10, view_5);
  }
  view.fbb(p_0, view_0);
  var tmp_13 = _this__u8e3s4.lgy();
  var topLevelScopes = lensFilter(tmp_13, scopeV3$lambda);
  var tmp_14 = shownWhen(view, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.baj(topLevelScopes).i1();
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_6 = view.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
  view.ebb(p_6, view_6);
  view_6.xbm(true);
  if (get_viewIsWide(view_6)) {
    view_6.zb8(get_px(0));
  }
  // Inline function 'com.crowpay.views.theming.subTitle' call
  var content_0 = 'Work Groups';
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (TextView())(view_6.pc());
  var tmp0_elvis_lhs_7 = view_6.cbb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
  view_6.ebb(p_7, view_7);
  view_7.jba(view_7.ob6_1.ybe(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_15 = view_7.tb5_1;
  var tmp_16;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content_0) === 0) {
    tmp_16 = '\xA0';
  } else {
    tmp_16 = content_0;
  }
  tmp_15.fbu(tmp_16);
  view_6.fbb(p_7, view_7);
  var tmp_17 = view_6.hbb(ListSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (RowOrCol())(view_6.pc());
  var tmp0_elvis_lhs_8 = view_6.cbb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_6 : tmp0_elvis_lhs_8;
  view_6.ebb(p_8, view_8);
  view_8.xbm(true);
  if (get_viewIsWide(view_8)) {
    view_8.zb8(get_px(0));
  }
  var tmp_18 = scopeV3$slambda_4(topLevelScopes);
  var tmp_19 = _this__u8e3s4.rgj().equals(ProjectLens_Contractor_getInstance());
  forEachMaybeReorderable(view_8, topLevelScopes, 'work-groups', tmp_18, tmp_19, VOID, ($this$forEachMaybeReorderable, scope, dragData) => renderScopeView(_this__u8e3s4, scope, dragData, $this$forEachMaybeReorderable));
  view_6.fbb(p_8, view_8);
  view_6.jbb(tmp_17, view_8);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (Space())(view_6.pc());
  var tmp0_elvis_lhs_9 = view_6.cbb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_6 : tmp0_elvis_lhs_9;
  view_6.ebb(p_9, view_9);
  view_6.fbb(p_9, view_9);
  view.fbb(p_6, view_6);
  view.jbb(tmp_14, view_6);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (Space())(view.pc(), 5.0);
  var tmp0_elvis_lhs_10 = view.cbb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view : tmp0_elvis_lhs_10;
  view.ebb(p_10, view_10);
  view.fbb(p_10, view_10);
  writer.fbb(p, view);
  return view;
}
function actions(_this__u8e3s4, writer) {
  // Inline function 'kotlin.with' call
  var tmp;
  if (get_viewIsWide(writer)) {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())(writer.pc());
    var tmp0_elvis_lhs = writer.cbb_1;
    var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
    writer.ebb(p, view);
    view.xbm(false);
    view.jbb(get_atTopStart(view), actions$startWorkButton(view, _this__u8e3s4));
    var tmp_0 = get_expanding(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Space())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view.fbb(p_0, view_0);
    view.jbb(tmp_0, view_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
    var breakpoint = get_AppDimensions().gg2_1;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowCollapsingToColumn())(view.pc(), listOf(new (Dimension())(breakpoint)));
    var tmp0_elvis_lhs_1 = view.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.ebb(p_1, view_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RowOrCol())(view_1.pc());
    var tmp0_elvis_lhs_2 = view_1.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
    view_1.ebb(p_2, view_2);
    view_2.xbm(false);
    actions$addScopeSetButton(view_2, _this__u8e3s4);
    actions$addScopeViewButton(view_2, _this__u8e3s4);
    view_1.fbb(p_2, view_2);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (RowOrCol())(view_1.pc());
    var tmp0_elvis_lhs_3 = view_1.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
    view_1.ebb(p_3, view_3);
    view_3.xbm(false);
    actions$addWorkNoteButton(view_3, _this__u8e3s4);
    actions$addWorkTaskButton(view_3, _this__u8e3s4);
    view_1.fbb(p_3, view_3);
    view.fbb(p_1, view_1);
    writer.fbb(p, view);
    tmp = view;
  } else {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (RowOrCol())(writer.pc());
    var tmp0_elvis_lhs_4 = writer.cbb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? writer : tmp0_elvis_lhs_4;
    writer.ebb(p_4, view_4);
    view_4.xbm(true);
    view_4.zb8(get_AppDimensions().ig2_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (RowOrCol())(view_4.pc());
    var tmp0_elvis_lhs_5 = view_4.cbb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
    view_4.ebb(p_5, view_5);
    view_5.xbm(false);
    view_5.zb8(get_AppDimensions().ig2_1);
    view_5.jbb(get_expanding(view_5), actions$startWorkButton(view_5, _this__u8e3s4));
    view_5.jbb(get_expanding(view_5), actions$addScopeSetButton(view_5, _this__u8e3s4));
    view_5.jbb(get_expanding(view_5), actions$addScopeViewButton(view_5, _this__u8e3s4));
    view_4.fbb(p_5, view_5);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_6 = new (RowOrCol())(view_4.pc());
    var tmp0_elvis_lhs_6 = view_4.cbb_1;
    var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
    view_4.ebb(p_6, view_6);
    view_6.xbm(false);
    view_6.zb8(get_AppDimensions().ig2_1);
    view_6.jbb(get_expanding(view_6), actions$addWorkNoteButton(view_6, _this__u8e3s4));
    view_6.jbb(get_expanding(view_6), actions$addWorkTaskButton(view_6, _this__u8e3s4));
    view_4.fbb(p_6, view_6);
    writer.fbb(p_4, view_4);
    tmp = view_4;
  }
  return tmp;
}
function actions$centeredText(_this__u8e3s4, content) {
  return get_viewIsWide(_this__u8e3s4) ? specCenteredText(_this__u8e3s4, content) : _this__u8e3s4.jbb(get_centered(_this__u8e3s4), body(_this__u8e3s4, content));
}
function actions$centeredContent(_this__u8e3s4, content) {
  var tmp;
  if (get_viewIsWide(_this__u8e3s4)) {
    tmp = specCenteredContent(_this__u8e3s4, VOID, ($this$specCenteredContent) => {
      var tmp = get_compact($this$specCenteredContent);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      var setup = content;
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())($this$specCenteredContent.pc());
      var tmp0_elvis_lhs = $this$specCenteredContent.cbb_1;
      var p = tmp0_elvis_lhs == null ? $this$specCenteredContent : tmp0_elvis_lhs;
      $this$specCenteredContent.ebb(p, view);
      view.xbm(false);
      setup(view);
      $this$specCenteredContent.fbb(p, view);
      return $this$specCenteredContent.jbb(tmp, view);
    });
  } else {
    var tmp_0 = _this__u8e3s4.ibb(get_centered(_this__u8e3s4), get_compact(_this__u8e3s4));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
    var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
    _this__u8e3s4.ebb(p, view);
    view.xbm(false);
    content(view);
    _this__u8e3s4.fbb(p, view);
    tmp = _this__u8e3s4.jbb(tmp_0, view);
  }
  return tmp;
}
function actions$startWorkButton(_this__u8e3s4, $this_actions) {
  var tmp = _this__u8e3s4.ibb(shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => {
    var tmp;
    if ($this$shownWhen.baj($this_actions.kgj_1) && setOf_0([ProjectState_PendingStart_getInstance(), ProjectState_InProgress_getInstance()]).t1($this$shownWhen.baj($this_actions.jfy()).w7b_1)) {
      var tmp0 = $this$shownWhen.baj($this_actions.tgm());
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0, Collection())) {
          tmp_0 = tmp0.i1();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (element.lfy() == null) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }
      tmp = tmp$ret$0;
    } else {
      tmp = false;
    }
    return tmp;
  }), get_primaryButton(_this__u8e3s4));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  actions$centeredText(view, get_viewIsWide(view) ? 'Start Work Items' : 'Start Work');
  onClick(view, 'Start Work Items', VOID, actions$startWorkButton$slambda_0($this_actions));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function actions$addScopeSetButton(_this__u8e3s4, $this_actions) {
  var tmp = _this__u8e3s4.ibb(shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => $this$shownWhen.baj($this_actions.kgj_1)), get_secondaryButton(_this__u8e3s4));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  if (get_viewIsWide(view)) {
    actions$centeredContent(view, actions$addScopeSetButton$lambda);
  } else
    actions$centeredText(view, '+ Scope Set');
  onClick(view, VOID, VOID, actions$addScopeSetButton$slambda_0($this_actions));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function actions$addScopeViewButton(_this__u8e3s4, $this_actions) {
  var tmp = _this__u8e3s4.ibb(shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => $this$shownWhen.baj($this_actions.kgj_1)), get_secondaryButton(_this__u8e3s4));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  if (get_viewIsWide(view)) {
    actions$centeredContent(view, actions$addScopeViewButton$lambda);
  } else
    actions$centeredText(view, '+ Scope View');
  onClick(view, VOID, VOID, actions$addScopeViewButton$slambda_0($this_actions));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function actions$addWorkNoteButton(_this__u8e3s4, $this_actions) {
  var tmp = get_tertiaryButton(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  var tmp_0 = KMutableProperty0();
  var tmp_1 = Button$_get_enabled_$ref_61t7nx(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('enabled', 0, tmp_0, tmp_1, Button$_set_enabled_$ref_o8kynz(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp;
    if (newNotesAllowed_0($this$reactiveScope.baj($this_actions.jfy()).w7b_1)) {
      var tmp0 = $this$reactiveScope.baj($this_actions.tgm());
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0, Collection())) {
          tmp_0 = tmp0.i1();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (newNotesAllowed(element.kfy())) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }
      tmp = tmp$ret$0;
    } else {
      tmp = false;
    }
    var tmp$ret$2 = tmp;
    this_0.set(tmp$ret$2);
    return Unit_instance;
  });
  actions$centeredText(view, '+ Work Note');
  onClick(view, VOID, VOID, actions$addWorkNoteButton$slambda_0($this_actions));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function actions$addWorkTaskButton(_this__u8e3s4, $this_actions) {
  var tmp = get_tertiaryButton(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  var tmp_0 = KMutableProperty0();
  var tmp_1 = Button$_get_enabled_$ref_61t7nx_0(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('enabled', 0, tmp_0, tmp_1, Button$_set_enabled_$ref_o8kynz_0(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp;
    var tmp0 = $this$reactiveScope.baj($this_actions.tgm());
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(tmp0, Collection())) {
        tmp_0 = tmp0.i1();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (newTasksAllowed(element.kfy())) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    if (tmp$ret$0) {
      tmp = newTasksAllowed_0($this$reactiveScope.baj($this_actions.jfy()).w7b_1);
    } else {
      tmp = false;
    }
    var tmp$ret$2 = tmp;
    this_0.set(tmp$ret$2);
    return Unit_instance;
  });
  actions$centeredText(view, '+ Work Task');
  onClick(view, VOID, VOID, actions$addWorkTaskButton$slambda_0($this_actions));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function RowOrCol$_get_shown_$ref_m8lfse(p0) {
  return () => p0.wb8();
}
function RowOrCol$_set_shown_$ref_7290m6(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8($this, move, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.gi1_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.map' call
  var this_1 = tmp;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$1 = item.hf9_1;
    destination.v(tmp$ret$1);
  }
  var tmp_0 = destination;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = get_session();
  var tmp_1 = await_0(this_2, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$4 = tmp_1;
  var tmp_2 = reorder(move, tmp_0, tmp$ret$4.mfv_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
var scopeV3$slambdaClass;
function scopeV3$slambda() {
  if (scopeV3$slambdaClass === VOID) {
    class $ {
      constructor($individualItems) {
        this.gi1_1 = $individualItems;
      }
      dhm(move, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, move), $completion);
      }
      s2(p1, $completion) {
        return this.dhm(p1 instanceof Move() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    scopeV3$slambdaClass = $;
  }
  return scopeV3$slambdaClass;
}
function scopeV3$slambda_0($individualItems) {
  var i = new (scopeV3$slambda())($individualItems);
  var l = (move, $completion) => i.dhm(move, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  var tmp = JumpTo_getInstance().rg3_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.hi1_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.kf9_1;
  tmp.xg4(tmp_1, $this.ii1_1, VOID, () => {
    $this.ji1_1.mam(true);
    return Unit_instance;
  });
  return Unit_instance;
}
var scopeV3$lambda$slambdaClass;
function scopeV3$lambda$slambda() {
  if (scopeV3$lambda$slambdaClass === VOID) {
    class $ {
      constructor($item, $row, $expand) {
        this.hi1_1 = $item;
        this.ii1_1 = $row;
        this.ji1_1 = $expand;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    scopeV3$lambda$slambdaClass = $;
  }
  return scopeV3$lambda$slambdaClass;
}
function scopeV3$lambda$slambda_0($item, $row, $expand) {
  var i = new (scopeV3$lambda$slambda())($item, $row, $expand);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, move, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ki1_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.map' call
  var this_1 = tmp;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$1 = item.hf9_1;
    destination.v(tmp$ret$1);
  }
  var tmp_0 = destination;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = get_session();
  var tmp_1 = await_0(this_2, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$4 = tmp_1;
  var tmp_2 = reorder(move, tmp_0, tmp$ret$4.mfv_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
var scopeV3$slambdaClass_0;
function scopeV3$slambda_1() {
  if (scopeV3$slambdaClass_0 === VOID) {
    class $ {
      constructor($individualItems) {
        this.ki1_1 = $individualItems;
      }
      dhm(move, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, move), $completion);
      }
      s2(p1, $completion) {
        return this.dhm(p1 instanceof Move() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    scopeV3$slambdaClass_0 = $;
  }
  return scopeV3$slambdaClass_0;
}
function scopeV3$slambda_2($individualItems) {
  var i = new (scopeV3$slambda_1())($individualItems);
  var l = (move, $completion) => i.dhm(move, $completion);
  l.$arity = 1;
  return l;
}
function scopeV3$lambda(it) {
  return it.q7z_1 == null;
}
function *_generator_invoke__zhh2q8_2($this, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.li1_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = reorder(it, tmp_0, tmp$ret$1.ufv_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
var scopeV3$slambdaClass_1;
function scopeV3$slambda_3() {
  if (scopeV3$slambdaClass_1 === VOID) {
    class $ {
      constructor($topLevelScopes) {
        this.li1_1 = $topLevelScopes;
      }
      dhm(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.dhm(p1 instanceof Move() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    scopeV3$slambdaClass_1 = $;
  }
  return scopeV3$slambdaClass_1;
}
function scopeV3$slambda_4($topLevelScopes) {
  var i = new (scopeV3$slambda_3())($topLevelScopes);
  var l = (it, $completion) => i.dhm(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.mi1_1.jfy();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.mi1_1.tgm();
  var tmp_2 = await_0(this_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp_2;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (element.kfy().equals(LineItemState_NotStarted_getInstance())) {
      destination.v(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList().u(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var item = _iterator__ex2g4s_0.o1();
    var tmp$ret$5 = item.hf9_1;
    destination_0.v(tmp$ret$5);
  }
  var tmp_3 = destination_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.mi1_1.lgy();
  var tmp_4 = await_0(this_2, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp$ret$8 = tmp_4;
  tmp.xgd(new (StartWorkItemsDialog())(tmp_1, tmp_3, tmp$ret$8));
  return Unit_instance;
}
var actions$startWorkButton$slambdaClass;
function actions$startWorkButton$slambda() {
  if (actions$startWorkButton$slambdaClass === VOID) {
    class $ {
      constructor($this_actions) {
        this.mi1_1 = $this_actions;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    actions$startWorkButton$slambdaClass = $;
  }
  return actions$startWorkButton$slambdaClass;
}
function actions$startWorkButton$slambda_0($this_actions) {
  var i = new (actions$startWorkButton$slambda())($this_actions);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function actions$addScopeSetButton$lambda($this$centeredContent) {
  $this$centeredContent.jbb(get_centered($this$centeredContent), body($this$centeredContent, '+ Scope Set'));
  $this$centeredContent.jbb(get_centered($this$centeredContent), infoBubble($this$centeredContent, 'Group items for a connected Sign-Off for those items.'));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ni1_1.tgm();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$0 = tmp_0;
  tmp.xgd(NewScopeViewDialog(tmp$ret$0, true));
  return Unit_instance;
}
var actions$addScopeSetButton$slambdaClass;
function actions$addScopeSetButton$slambda() {
  if (actions$addScopeSetButton$slambdaClass === VOID) {
    class $ {
      constructor($this_actions) {
        this.ni1_1 = $this_actions;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    actions$addScopeSetButton$slambdaClass = $;
  }
  return actions$addScopeSetButton$slambdaClass;
}
function actions$addScopeSetButton$slambda_0($this_actions) {
  var i = new (actions$addScopeSetButton$slambda())($this_actions);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function actions$addScopeViewButton$lambda($this$centeredContent) {
  $this$centeredContent.jbb(get_centered($this$centeredContent), body($this$centeredContent, '+ Scope View'));
  $this$centeredContent.jbb(get_centered($this$centeredContent), infoBubble($this$centeredContent, 'Group items for ease of display and presentation.'));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.oi1_1.tgm();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$0 = tmp_0;
  tmp.xgd(NewScopeViewDialog(tmp$ret$0, false));
  return Unit_instance;
}
var actions$addScopeViewButton$slambdaClass;
function actions$addScopeViewButton$slambda() {
  if (actions$addScopeViewButton$slambdaClass === VOID) {
    class $ {
      constructor($this_actions) {
        this.oi1_1 = $this_actions;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    actions$addScopeViewButton$slambdaClass = $;
  }
  return actions$addScopeViewButton$slambdaClass;
}
function actions$addScopeViewButton$slambda_0($this_actions) {
  var i = new (actions$addScopeViewButton$slambda())($this_actions);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.pi1_1.tgm();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp_0;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (newNotesAllowed(element.kfy())) {
      destination.v(element);
    }
  }
  tmp.xgd(new (RootCreateItemNote())(destination));
  return Unit_instance;
}
var actions$addWorkNoteButton$slambdaClass;
function actions$addWorkNoteButton$slambda() {
  if (actions$addWorkNoteButton$slambdaClass === VOID) {
    class $ {
      constructor($this_actions) {
        this.pi1_1 = $this_actions;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    actions$addWorkNoteButton$slambdaClass = $;
  }
  return actions$addWorkNoteButton$slambdaClass;
}
function actions$addWorkNoteButton$slambda_0($this_actions) {
  var i = new (actions$addWorkNoteButton$slambda())($this_actions);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.qi1_1.tgm();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp_0;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (element.kfy().d4(LineItemState_Complete_getInstance()) < 0) {
      destination.v(element);
    }
  }
  tmp.xgd(new (RootCreateItemTask())(destination));
  return Unit_instance;
}
var actions$addWorkTaskButton$slambdaClass;
function actions$addWorkTaskButton$slambda() {
  if (actions$addWorkTaskButton$slambdaClass === VOID) {
    class $ {
      constructor($this_actions) {
        this.qi1_1 = $this_actions;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    actions$addWorkTaskButton$slambdaClass = $;
  }
  return actions$addWorkTaskButton$slambdaClass;
}
function actions$addWorkTaskButton$slambda_0($this_actions) {
  var i = new (actions$addWorkTaskButton$slambda())($this_actions);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  scopeV3 as scopeV318fctfa38mngh,
};
//endregion

//# sourceMappingURL=scopev3.mjs.map
